import App from "../Core/App";

import BaseComponent from "./BaseComponent";

export default class PersonTable extends BaseComponent {
    constructor() {
        super();

        if($('.blb-personlist').length > 0){
            $('.blb-personlist-more-btn').on('click', function(e){
                $(e.target).parent().parent().siblings().find('.blb-personlist-more-btn.active').click();
                $(e.target).toggleClass('active');
                let text = $(e.target).siblings('.blb-personlist-more-text');
                if(text.height() == 0){
                    text.css('height', text[0].scrollHeight+'px');
                } else {
                    text.css('height', '0');
                }
            });
        }
    }

}